<template>
  <div class="body-wrapper">
    <div class="container-fluid">
      <div class="card card-body">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="d-sm-flex align-items-center justify-space-between">
              <h4 class="fw-semibold fs-4 mb-4 mb-md-0 card-title">Solicitar Coleta</h4>
              <nav aria-label="breadcrumb" class="ms-auto">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item" aria-current="page">
                    <router-link to="/coletas" type="submit" class="btn btn-primary btn-sm hstack gap-6">
                      <i class="ti ti-arrow-back fs-4"></i>
                      Voltar para lista
                    </router-link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Informações</h4>
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Responsável no Local</label>
                    <input type="text" class="form-control" id="weight"
                      placeholder="Que estará responsavel no local da coleta?" v-model="responsible" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label" for="address_id">Endereço de coleta {{ (loadingAddress) ? "(Escolha um cliente...)" : "" }}</label>
                    <select class="form-select" id="address_id" v-model="address_id" :disabled="loadingAddress" @change="setAddress">
                      <option value="0">Escolha um endereço</option>
                      <option v-for="item in listAddress" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Peso da carga (KG)</label>
                    <input type="number" class="form-control" id="weight" v-model="weight" placeholder="Ex.: 100.00" />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label" for="suitable_date">Data para coletar</label>
                    <input type="date" class="form-control" id="suitable_date" v-model="date" />
                  </div>
                </div>
                <div class="col-md-4" v-if="role > 3">
                  <div class="mb-3">
                    <label class="form-label" for="user_id">Cliente</label>
                    <select class="form-select" id="user_id" v-model="user_id" :disabled="loadingClient"
                      @change="loadAddress">
                      <option value="0">Escolha um Cliente</option>
                      <option v-for="item in list" :key="item.user_id" :value="item.user_id">{{ item.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label" for="address_id">Situação</label>
                    <select class="form-select" id="address_id" v-model="status_id">
                      <option value="0">Escolha uma situação</option>
                      <option v-for="item in listStatus" :key="item.user_id" :value="item.id">{{ item.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">CEP</label>
                    <input v-model="zip_code" type="text" class="form-control" placeholder="Aguardando..." v-maska="'#####-###'"
                      @change="searchCEP" disabled/>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label">Rua (Ex.: Rua das neves)</label>
                    <input v-model="street" type="email" class="form-control" placeholder="Aguardando..." disabled/>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Número</label>
                    <input v-model="street_number" type="text" class="form-control" placeholder="Aguardando..." disabled />
                    
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Bairro</label>
                    <input v-model="neighbohood" type="email" class="form-control" placeholder="Aguardando..." disabled/>
                   
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">Cidade</label>
                    <input v-model="city" type="email" class="form-control" placeholder="Aguardando..." disabled/>
                    
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">Estado</label>
                    <input v-model="state" type="email" class="form-control" placeholder="Aguardando..." disabled/>
                  
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label" for="address_id">Tem as informações de transporte?</label>
                    <select class="form-select" id="address_id" v-model="status_truck">
                      <option value="0">Escolha uma situação</option>
                      <option value="1">Sim</option>
                      <option value="2">Não</option>
                    </select>
                  </div>
                </div>
                <h4 class="card-title mb-3 mt-4">Transporte</h4>
                <div class="col-12" v-show="status_truck != 1">
                  <div class="mb-3">
                    <label class="form-label">Sem informação de Transporte (Caso tenha, selecione na opção Sim em "Tem as informações de transporte?)</label>
                  </div>
                </div>
              </div>
              <div class="row" v-show="status_truck == 1"> 
                

                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label" for="respCollection">Responsável por coletar</label>
                    <input type="text" class="form-control" id="respCollection"
                      placeholder="Que estará responsavel ir coletar?" v-model="name_truck" />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="rg">RG</label>
                    <input type="text" class="form-control" id="rg" placeholder="0.000.000" v-model="rg_truck" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="cpf">CPF</label>
                    <input type="text" class="form-control" id="cpf" placeholder="000.000.000-00" v-model="cpf_truck" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Placa do Caminhão</label>
                    <input type="text" class="form-control" id="plateTruck" placeholder="XXXXXX"
                      v-model="license_plate" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Modelo do Caminhão</label>
                    <input type="text" class="form-control" id="plateTruck" placeholder="Modelo X"
                      v-model="trucker_model" />
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Empresa do responsável</label>
                    <input type="text" class="form-control" id="plateTruck" placeholder="Nome da empresa responsável"
                      v-model="entity_truck" />
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Link de rastreio</label>
                    <input type="text" class="form-control" id="plateTruck" placeholder="Link para restreamento"
                      v-model="tracker_link" />
                  </div>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-12">
                  <div class="d-md-flex align-items-center">
                    <div class="ms-auto mt-3 mt-md-0">
                      <button type="submit" class="btn btn-primary hstack gap-6" @click="create">
                        <i class="ti ti-plus fs-4"></i>
                        Solicitar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import App from '@/App.vue';

export default {
  mixins: [
    App
  ],
  data() {
    return {
      individual: null,
      role: 0,
      date: '',
      responsible: '',
      address_id: 0,
      weight: 0,
      name_truck: '',
      rg_truck: '',
      cpf_truck: '',
      license_plate: '',
      trucker_model: '',
      entity_truck: '',
      tracker_link: '',

      user_id: 0,
      status_id: 0,
      zip_code: '',
      street: '',
      street_number: '',
      neighbohood: '',
      city: '',
      state: '',
      typeUser: 2,
      list: [],
      listAddress: [],
      listStatus: [],
      loadingAddress: true,
      loadingClients: true,
      status_truck: 0,
    }
  },
  methods: {
    create() {
      const json = {
        date: this.date,
        responsible: this.responsible,
        address_id: this.address_id,
        weight: this.weight,
        name_truck: this.name_truck,
        rg_truck: this.rg_truck,
        cpf_truck: this.cpf_truck,
        license_plate: this.license_plate,
        trucker_model: this.trucker_model,
        entity_truck: this.entity_truck,
        tracker_link: this.tracker_link,
        user_id: this.user_id,
        status_id: this.status_id
      }

      this.$http.post('/pickup', json, {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then((response) => {
        this.showAlert('success', response.data.message);
        this.$router.push('/coletas/aberta');
      }).catch(error => {
        this.showAlert('error', error.response.data);
      });
    },
    loadClients() {
      this.$http.get('/list/user/' + this.typeUser, {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.list = response.data.items
        this.loadingClients = false;
      })
    },

    loadAddress() {
      if (this.user_id == 0) return;

      this.listAddress = [];

      this.$http.get('/list/address/' + this.user_id, {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.listAddress = response.data.items
        this.loadingAddress = false;
      })
    },
    loadStatus() {
      this.$http.get('/status', {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.listStatus = response.data.items
      })
    },
    setAddress() {

      if (this.address_id == 0) {
        this.zip_code = '';
        this.street = '';
        this.street_number = '';
        this.neighbohood = '';
        this.city = '';
        this.state = '';
        return;
      }

      const selectedAddress = this.listAddress.find(item => item.id == this.address_id);

      if (selectedAddress) {
        this.zip_code = selectedAddress.zip_code || '';
        this.street = selectedAddress.street || '';
        this.street_number = selectedAddress.street_number || '';
        this.neighbohood = selectedAddress.neighbohood || '';
        this.city = selectedAddress.city || '';
        this.state = selectedAddress.state || '';
      }
    }
  },
  created() {
    this.role = this.$store.state.role;
    this.individual = JSON.parse(Cookies.get('individual'));
    if(this.role < 3){
        this.user_id = this.individual.user_id;
        this.loadAddress();
    }
    
  },
  mounted() {
    this.loadClients();
    this.loadStatus();
  }
}
</script>
